import { InjectionToken } from '@angular/core';

export const CONTENT_COMPONENTS = new InjectionToken<{ [key: string]: any }>('Content DSL Items');

export interface ContentDSLComponentOutline {
    componentName: string;
    componentInputs: { [key: string]: any };
    componentProjectedHtml: string;
}

export enum ContentPrefix {
    BUSINESS = 'business'
}
